import { render } from "./BonoHowItWorksNumber.vue?vue&type=template&id=194b0ae6"
import script from "./BonoHowItWorksNumber.vue?vue&type=script&lang=js"
export * from "./BonoHowItWorksNumber.vue?vue&type=script&lang=js"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__